import instances from '../config/axios';
import { ENABLE_MOCKS } from '../constants/common';
import {
  invoicesList,
  invoiceById,
  registeredSolution,
  certificationCounts,
  invoicesCounts,
  OTPs,
  sellerInvoiceView,
  buyerInvoiceView,
} from './mocks';

export const generateOtp = async (vat, numberOfOTPs = 1) => {
  return ENABLE_MOCKS
    ? OTPs(numberOfOTPs)
    : instances.otpInstance.get(`/core/otp/generate?otpCount=${numberOfOTPs}`, {
        headers: { vatNumber: vat },
      });
};

export const startProcess = () => {
  return instances.servicesInstance.post(
    '/onboarding/start',
    {},
    {
      headers: {
        callLogin: false,
      },
    },
  );
};

export const generateInvoice = (data) => {
  return instances.smeInstance.post('/invoices', data);
};

export const getInvoicesList = async (taxnumber) => {
  return ENABLE_MOCKS
    ? invoicesList()
    : instances.smeInstance.get('/invoices/taxnumber', {
        headers: {
          taxnumber,
        },
      });
};

export const getInvoiceById = async (id, tax_number) => {
  return ENABLE_MOCKS
    ? invoiceById()
    : instances.smeInstance.get('/invoices/' + id, {
        headers: {
          tax_number,
        },
      });
};

export const getStatistics = async (tax_number) => {
  const certificationsNew = certificationCounts();
  const eInvoicingNew = invoicesCounts();
  const statistics = {
    data: {
      certifications: {
        ...certificationsNew?.data,
      },
      clearance: {
        ...eInvoicingNew?.data?.clearance,
      },
      reporting: {
        ...eInvoicingNew?.data?.reporting,
      },
    },
  };

  if (ENABLE_MOCKS) {
    return statistics;
  }

  const certifications = await instances.statisticsInstance.get(
    `/core/statistics/onboarding?vat=${tax_number}`,
  );
  const eInvoicing = await instances.statisticsInstance.get(
    `/core/statistics/invoiceStatistics?vat=${tax_number}`,
  );
  if (certifications && eInvoicing) {
    return {
      data: {
        certifications: {
          ...certifications?.data,
        },
        clearance: {
          ...eInvoicing?.data?.clearance,
        },
        reporting: {
          ...eInvoicing?.data?.reporting,
        },
      },
    };
  } else {
    throw new Error('');
  }
};

export const getInvoiceOnboardData = (tax_number, invoiceType) => {
  return instances.smeInstance.get(
    `/invoices/onboard/${tax_number}?invoiceType=${invoiceType}`,
  );
};

export const printInvoice = (uuid) => {
  return instances.smeInstance.get(`invoices/${uuid}/pdf`, {
    responseType: 'blob',
  });
};

export const getRegisteredSolutions = async (taxNumber) => {
  return ENABLE_MOCKS
    ? registeredSolution()
    : instances.onboardingInstance.get('/?vatNumber=' + taxNumber);
};

export const getTaxReturnsList = async (taxNumber) => {
  return instances.taxReturnServiceInstance.get('/return/getReports', {
    headers: {
      vatNumber: taxNumber,
    },
  });
};

export const getDataByPeriod = ({
  taxnumber,
  startDate,
  endDate,
  periodCount,
  referenceNumber = null,
}) => {
  if (referenceNumber === 'null' || referenceNumber === null) {
    referenceNumber = '';
  }
  return instances.taxReturnServiceInstance.get(
    '/return/getReportDataByPeriod',
    {
      headers: {
        vatNumber: taxnumber,
        startDate,
        endDate,
        'Period-Count': periodCount,
        referenceNumber,
      },
    },
  );
};

export const approveReturn = ({
  vatNumber,
  startDate,
  endDate,
  periodCount,
  data,
}) => {
  return instances.taxReturnServiceInstance.post(
    '/return/approveReturn',
    data,
    {
      headers: {
        'Period-Count': periodCount,
        vatNumber,
        startDate,
        endDate,
      },
    },
  );
};

export const getSalesRegister = ({
  taxNumber,
  dateFrom,
  dateTo,
  invoiceType,
  searchQuery,
}) => {
  return instances.taxReturnServiceInstance.get('/return/sales', {
    headers: {
      taxnumber: taxNumber,
    },
    params: {
      dateFrom,
      dateTo,
      invoiceType,
      searchQuery,
    },
  });
};

export const getPurchasesRegister = ({
  taxNumber,
  dateFrom,
  dateTo,
  invoiceType,
  searchQuery,
}) => {
  return instances.taxReturnServiceInstance.get('/return/purchases', {
    headers: {
      taxnumber: taxNumber,
    },
    params: {
      dateFrom,
      dateTo,
      invoiceType,
      searchQuery,
    },
  });
};

export const revokeCertificate = async (requestId, tax_number) => {
  return instances.onboardingInstance.delete('/portal', {
    headers: {
      'Production-Request-Id': requestId,
      vatNumber: tax_number,
    },
  });
};

export const getInvoiceViewBySellerTaxId = async (sellerTaxId) => {
  if (ENABLE_MOCKS) {
    return sellerInvoiceView();
  }
  return instances.smeInstance.get(
    `/invoices/getAllTaxDataBySellerTaxId/${sellerTaxId}`,
  );
};

export const getInvoiceViewByBuyerTaxId = async (buyerTaxId) => {
  if (ENABLE_MOCKS) {
    return buyerInvoiceView();
  }
  return instances.smeInstance.get(
    `/invoices/getAllTaxDataByBuyerTaxId/${buyerTaxId}`,
  );
};
